// extracted by mini-css-extract-plugin
module.exports = {"bubblesContainer":"ProductResults_bubblesContainer__skaqJ","insuranceLabel":"ProductResults_insuranceLabel__tcUWL","bg-spin":"ProductResults_bg-spin__1HQPX"};